import { ActivityLinesIcon } from '@jouzen/ecom-components/icons/ActivityLinesIcon';
import { ArticleIcon } from '@jouzen/ecom-components/icons/ArticleIcon';
import { DiamondIcon } from '@jouzen/ecom-components/icons/DiamondIcon';
import { MeditationIcon } from '@jouzen/ecom-components/icons/MeditationIcon';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

const ICON_SIZE = 32;

const BusinessMenu = () => {
  const t = useTranslations();

  return (
    <section data-cy="business-menu">
      <LayoutGrid className="mb-16 md:gap-y-16 lg:gap-y-0 lg:pb-20">
        <GridItem
          className="flex flex-col items-center justify-center gap-6 border-sandstone-400 px-5 sm:border-b-2 sm:py-16 md:border-r-2 md:border-b-0 md:py-0"
          colStart={{ sm: 'main' }}
          colEnd={{ sm: 'main', md: 12, lg: 6 }}
        >
          <DiamondIcon width={ICON_SIZE} height={ICON_SIZE} />
          <Typography align="center">
            {t('business_menu_gifting_and_rewards')}
          </Typography>
        </GridItem>
        <GridItem
          className="flex flex-col items-center justify-center gap-6 border-sandstone-400 px-5 sm:border-b-2 sm:py-16 md:border-b-0 md:py-0 lg:border-r-2"
          colStart={{ sm: 'main', md: 12, lg: 6 }}
          colEnd={{ sm: 'main', lg: 12 }}
        >
          <MeditationIcon width={ICON_SIZE} height={ICON_SIZE} />
          <Typography align="center">
            {t('business_menu_employee_wellness')}
          </Typography>
        </GridItem>
        <GridItem
          className="flex flex-col items-center justify-center gap-6 border-sandstone-400 px-5 sm:border-b-2 sm:py-16 md:border-r-2 md:border-b-0 md:py-0"
          colStart={{
            sm: 'main',
            lg: 12,
          }}
          colEnd={{ sm: 'main', md: 12, lg: 18 }}
        >
          <ActivityLinesIcon width={ICON_SIZE} height={ICON_SIZE} />
          <Typography align="center">
            {t('business_menu_employee_hpr')}
          </Typography>
        </GridItem>
        <GridItem
          className="flex flex-col items-center justify-center gap-6 px-5 py-16 md:py-0 lg:mb-0"
          colStart={{ sm: 'main', md: 12, lg: 18 }}
          colEnd={{ sm: 'main' }}
        >
          <ArticleIcon width={ICON_SIZE} height={ICON_SIZE} />
          <Typography align="center">{t('business_menu_research')}</Typography>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default BusinessMenu;
